import { createReducerFromMap } from "@coverme/redux";

const initialState = {
    debts: [],
    expenses: [],
};

function updateLiabilities(state, data) {
    return {
        expenses: data.value.expenses || [],
        debts: data.value.debts || [],
    };
}

function resetInterview(state, action) {
    return initialState;
}

function getInterview(state, action) {
    const { value } = action;
    return updateLiabilities(state, { value: value.liabilities });
}

export const interviewLiabilitiesReducer = createReducerFromMap(initialState, {
    UPDATE_LIABILITIES_COMPLETE: updateLiabilities,
    RESET_INTERVIEW: resetInterview,
    GET_INTERVIEW_COMPLETE: getInterview,
});
